// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://galbbtjbrrrkcpzabhvc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdhbGJidGpicnJya2NwemFiaHZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzMzYxNDcsImV4cCI6MjA2NzkxMjE0N30.C_wzfTLfkpkdJ--nkxcsdYPuDiziP7ukf9w5MSGlPRU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});